import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../../components/layout';
import SEO from '../../../components/seo';
import { SettingProvider } from '../../../lib/context/settings';
import { AdsProvider } from '../../../lib/context/ads';
import { Col, Row } from 'antd';
import { Title } from '../../../components/styles';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const SchoolSafetyPatrolThankYou: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="School Safety Patrol - Thank You!"
              description=""
              canonicalUrl="/traffic-safety/highway-safety-initiatives/safety-patrol-thank-you"
            />

            <Row style={{ marginTop: 64, marginBottom: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title style={{ textAlign: 'center' }}>
                  SCHOOL SAFETY PATROL – THANK YOU!
                </Title>
                <p style={{ textAlign: 'center', marginTop: 24 }}>
                  Thanks for your interest. We’ll be in touch with you shortly.
                </p>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default SchoolSafetyPatrolThankYou;
